<div id="main" class="container">
  @if (!loading) {
    <app-timeline [data]="entities"></app-timeline>
  } @else {
    <app-timeline-skeleton></app-timeline-skeleton>
  }
</div>
